import type { Routes } from '@angular/router';
import { ssoAuthGuard } from './core/guards/sso-auth.guard';
import { ssoCallbackGuard } from './core/guards/sso-callback.guard';

export const routes: Routes = [
  {
    path: 'auth/callback',
    canActivate: [ssoCallbackGuard],
    loadComponent: () =>
      import('./core/components/auth-callback/auth-callback').then(m => m.AuthCallbackComponent),
    data: { title: 'Signing In' },
  },
  {
    path: 'auth/error',
    loadComponent: () =>
      import('./core/components/auth-error/auth-error').then(m => m.AuthErrorComponent),
    data: { title: 'Sign-in Error' },
  },
  { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
  {
    path: '',
    canActivate: [ssoAuthGuard],
    loadComponent: () =>
      import('./core/components/main-layout/main-layout').then(m => m.MainLayoutComponent),
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./modules/general-overview/components/general-overview-layout/general-overview-layout').then(
            m => m.GeneralOverviewLayout,
          ),
        data: { title: 'General Overview' },
      },
      {
        path: 'market-news',
        loadComponent: () =>
          import('./modules/market-news/components/market-news-layout/market-news-layout').then(
            m => m.MarketNewsLayout,
          ),
        data: { title: 'Market News & Insight' },
      },
      {
        path: 'data-shooter',
        loadComponent: () =>
          import('./modules/data-shooter/components/data-shooter-layout/data-shooter-layout').then(
            m => m.DataShooterLayout,
          ),
        data: { title: 'Data Shooter' },
      },
      {
        path: 'profile',
        loadComponent: () => import('./features/profile/profile').then(m => m.ProfileComponent),
        data: { title: 'User Profile' },
      },
      {
        path: 'material-components',
        loadComponent: () =>
          import('./features/material-components/material-components').then(
            m => m.MaterialComponentsComponent,
          ),
        data: { title: 'Material Components' },
      },
      {
        path: 'material-components',
        pathMatch: 'full',
        redirectTo: 'material-components',
      },
      {
        path: 'tutorials-guides',
        loadChildren: () =>
          import('./modules/tutorials-guides/tutorials-guides.routes').then(
            m => m.TUTORIALS_GUIDES_ROUTES,
          ),
      },
    ],
  },
  { path: '**', redirectTo: 'dashboard' },
];
